// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const forecast = false;

export const environment = {
  production: true,
  appVersion: '1',
  apiBaseUrl: 'https://dijifilo.com/api',
  staticBaseUrl: 'https://dijifilo.com/api/static',
  //  apiBaseUrl: 'https://dijifilo.com/api',
  //  staticBaseUrl: 'https://dijifilo.com/api/static',
  socketUrl: 'https://dijifilo.com/api',
  defaultAvatar: { path: '1642681241987_default-avatar.jpg', fileName: 'default-avatar.jpg', size: 4776 },
  homeUrl: '/orders',
  drawerLimit: 6,
  // VAPID public key for push notifications
  vapidPublicKey: 'BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuBkr3qBUYIHB24FLmSYFT7Zdc'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
